import React from 'react';
import { ViewMinimiseIcon } from '../../icons';
import CarInfoSection from './carInfoSection';
import { useDriversByPlateNumber } from '../../hooks/react-query/useDrivers';
import AsignedDriversCard from './asignedDriversCard';
import Loader from '../elements/loader';
import CarAssignMessage from './carAssignMessage';
import { checkBookingEnabled, checkDriverManage } from '../../utils/helper';

const CarDetailsView = ({
  selectedCar,
  handleViewState,
  handleAssignClick,
}) => {
  const { plateno, actions, MakeName, ModelName } = selectedCar;
  const isDriverManage = checkDriverManage(actions);

  const isBookingEnabled = checkBookingEnabled(actions);
  const { data: carDetails, isLoading } = useDriversByPlateNumber(
    plateno,
    isDriverManage
  );

  const { data = [] } = carDetails || {};
  const dataLength = data.length;
  return (
    <>
      {isDriverManage && isLoading && <Loader className="fill-primary" />}
      <div
        className={`flex flex-col pb-2 gap-2 ${
          dataLength ? 'justify-between' : 'gap-[72px]'
        } h-full`}
      >
        <div className="border-b border-solid border-[#E2E2E2] pb-10">
          <button className="flex gap-2 p-3" onClick={handleViewState}>
            <ViewMinimiseIcon />
            <span className="text-label">Ελαχιστοποίηση</span>
          </button>
          <CarInfoSection
            carData={selectedCar}
            hasDriver={dataLength && isBookingEnabled}
          />
        </div>
        {isDriverManage && !!dataLength ? (
          <div>
            <div className="flex justify-between px-6 items-center">
              <h4>Οδηγοί Αυτοκινήτου</h4>
              <button
                type="button"
                className="btn-secondary text-secondary-button"
                onClick={handleAssignClick}
              >
                Προσθήκη οδηγού
              </button>
            </div>
            <div className="flex gap-3 px-6 overflow-x-auto pb-3">
              {data.map((details) => {
                return (
                  <AsignedDriversCard
                    driverDetails={details}
                    key={details.id}
                    plateNumber={plateno}
                    carName={MakeName + ' ' + ModelName}
                  />
                );
              })}
            </div>
          </div>
        ) : (
          isDriverManage && (
            <CarAssignMessage handleAssignClick={handleAssignClick} />
          )
        )}
      </div>
    </>
  );
};

export default CarDetailsView;
